/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
`
export default class BanIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" css={Color}>
        <g id="그룹_5478" data-name="그룹 5478" transform="translate(-1152.808 -1397.806)">
          <rect id="사각형_5474" data-name="사각형 5474" width="16" height="16" transform="translate(1152.808 1397.806)" fill="#845757" opacity="0"/>
          <path id="패스_5237" data-name="패스 5237" d="M1160.808,1397.905a7.9,7.9,0,1,0,7.9,7.9A7.909,7.909,0,0,0,1160.808,1397.905Zm-6.6,7.9a6.588,6.588,0,0,1,10.114-5.577l-8.093,10.319A6.577,6.577,0,0,1,1154.208,1405.806Zm6.6,6.6a6.551,6.551,0,0,1-3.559-1.05l8.1-10.327a6.591,6.591,0,0,1-4.54,11.377Z" fill="#1c202b"/>
        </g>
      </svg>
    )
  }
}
